import React, { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Main/css/Main.css';

function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef('');

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // Remove the '#'
    }

    if (lastHash.current) {
      const element = document.getElementById(lastHash.current);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
          lastHash.current = ''; // Clear after scrolling
        }, 100); // Small timeout to ensure DOM is fully rendered
      }
    }
  }, [location]);
  return null;
}

function whatsappSVG() {
  return(
    <svg xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 32 32"
      fill="white">
        <path d="M16.04 3C8.84 3 3 8.84 3 16.04c0 2.3.6 4.53 1.74 6.49L3 29l6.68-1.71a13.01 13.01 0 0 0 6.36 1.63c7.2 0 13.04-5.84 13.04-13.04S23.24 3 16.04 3zm0 23.7c-2.01 0-3.98-.54-5.71-1.56l-.41-.24-3.97 1.01 1.06-3.87-.27-.4a10.6 10.6 0 0 1-1.63-5.6c0-5.91 4.81-10.72 10.72-10.72s10.72 4.81 10.72 10.72-4.81 10.66-10.72 10.66zm5.87-8.05c-.32-.16-1.9-.94-2.19-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.88-1.76-2.2-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.63-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.63s1.14 3.04 1.3 3.25c.16.21 2.25 3.44 5.45 4.82.76.33 1.35.53 1.81.68.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.17-1.53.27-.74.27-1.37.19-1.53-.08-.16-.29-.24-.61-.4z"/>
    </svg>
  )
}

export default function AllHeader() {
  return(
    <>
      <header className="header">
        <ScrollToAnchor />
        <div className="logo">P2P<span>AUTO</span></div>
        <nav>
          <ul>
            <li><Link to="/listing" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}>Buy A Car</Link></li>
            <li><Link to="/main#process">Sell A Car</Link></li>
            <li><Link to="/inspection" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}>Our Inspection</Link></li>
            <li><Link to="/main#process">How It Works</Link></li>
            <li><Link to="https://wa.me/601125829096">Contact Us</Link></li>
          </ul>
        </nav>
      </header>
      <header className="header-mobile">
        <div className="logo">P2P<span>AUTO</span></div>
        <Link className="btn" style={{padding:"6px 12px"}} to="https://wa.me/601125829096">{whatsappSVG()}</Link>
      </header>
    </>
  )
}